<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
          <v-alert type="error" class="alert" v-if="alert_delete === true">ลบข้อมูลเรียบร้อย !</v-alert>
        </v-slide-x-reverse-transition>
        <div class="pa-2">
          <div class="text-right ma-2">
            <v-btn x-large class="text-center grad-success-bg white--text mobile_btn" @click="create_modal = true">
              เพิ่มสาขา
            </v-btn>
          </div>
          <v-card-text>
            <div class="">
              <v-data-table :headers="header" :items="branch_list" key="index" :footer-props="footer_Props" mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>{{ dataDetail.index + 1 }}</td>
                    <td>{{ dataDetail.item.branch_name }}</td>
                    <td>{{ dataDetail.item.branch_telephone }}</td>
                    <td>
                      <div class="d-flex">
                        <v-icon>mdi-map-marker</v-icon>
                        <div><a class="hover_font" :href="dataDetail.item.branch_map" target="_blank">ดูแผนที่</a></div>
                      </div>
                    </td>
                    <td class="pa-3">
                      <v-btn small height="42" @click="edit_id(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                      <v-btn small height="42" @click="delete_data(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                        <v-icon>mdi-delete-empty-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </div>
      </v-card>
      <v-dialog v-model="create_modal" max-width="520">
        <v-card>
          <v-form ref="add_branch" @submit.prevent="save_data">
            <div class="d-flex justify-space-between">
              <v-card-title>
                เพิ่มสาขา
              </v-card-title>
              <v-btn icon class="ma-4" @click="create_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="mt-3 ma-1">
                <div class="ma-2">ชื่อสาขา <span style="color: red">*</span></div>
                <v-text-field color="#86bc3a" type="text" label="ชื่อสาขา" :rules="[v => !!v || 'กรุณากรอกชื่อสาขา']" v-model="send_data.branch_name" required hide-details="auto" outlined></v-text-field>
              </div>
              <div class="mt-3 ma-1">
                <div class="ma-2">เบอร์โทรติดต่อ <span style="color: red">*</span></div>
                <v-text-field color="#86bc3a" type="tel" maxlength="11" :rules="[v => !!v || 'กรุณากรอกเบอร์โทรติดต่อ']" @keypress="isNumber($event, send_data.telephone)" v-model="send_data.telephone" label="เบอร์โทรติดต่อ" required hide-details="auto" outlined></v-text-field>
              </div>
              <div class="mt-3 ma-1">
                <div class="ma-2">ลิ้งค์แแผนที่ <span style="color: red">*</span></div>
                <v-text-field color="#86bc3a" type="text" label="ลิ้งค์แแผนที่" :rules="[v => !!v || 'กรุณากรอกลิ้งค์แแผนที่']" v-model="send_data.map_link" required hide-details="auto" outlined></v-text-field>
              </div>
              <div class="text-center pt-6">
                <v-btn large class="white--text grad-success-bg mobile_btn" style="font-size: 18px" type="submit">บันทึก</v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="edit_modal" max-width="520">
        <v-card>
          <div v-if="loading_modal === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-form ref="edit_branch" @submit.prevent="edit_data">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  แก้ไขสาขา
                </v-card-title>
                <v-btn icon class="ma-4" @click="edit_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="mt-3 ma-1">
                  <div class="ma-2">ชื่อสาขา <span style="color: red">*</span></div>
                  <v-text-field color="#86bc3a" type="text" label="ชื่อสาขา" :rules="[v => !!v || 'กรุณากรอกชื่อสาขา']" v-model="edit_branch_list.branch_name" required hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <div class="ma-2">เบอร์โทรติดต่อ <span style="color: red">*</span></div>
                  <v-text-field color="#86bc3a" type="tel" maxlength="11" :rules="[v => !!v || 'กรุณากรอกเบอร์โทรติดต่อ']" @keypress="isNumber($event, edit_branch_list.branch_telephone)" v-model="edit_branch_list.branch_telephone" label="เบอร์โทรติดต่อ" required hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <div class="ma-2">ลิ้งค์แแผนที่ <span style="color: red">*</span></div>
                  <v-text-field color="#86bc3a" type="text" label="ลิ้งค์แแผนที่" :rules="[v => !!v || 'กรุณากรอกลิ้งค์แแผนที่']" v-model="edit_branch_list.branch_map" required hide-details="auto" outlined></v-text-field>
                </div>
                <div class="text-center pt-6">
                  <v-btn large class="white--text grad-success-bg mobile_btn" style="font-size: 18px" type="submit">บันทึก</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {isTelephone} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Branch_information",
  data() {
    return {
      loading_page: false,
      loading_modal: false,
      overlay: false,
      alert_success: false,
      alert_delete: false,
      create_modal: false,
      edit_modal: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      branch_id: null,
      header: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสาขา',
          value: 'branch_name',
          fixed: true,
          width: '250',
        },
        {
          text: 'เบอร์โทร',
          value: 'branch_telephone',
          fixed: true,
          width: '180px',
        },
        {
          text: 'Map.',
          value: 'branch_map',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      send_data: {
        branch_name: '',
        telephone: '',
        map_link: '',
      },
      branch_list: [],
      edit_branch_list: [],
    }
  },
  methods: {
    isNumber: function(evt, number) {
      return isTelephone(evt, number)
    },
    get_branch_data() {
      this.loading_page = true
      HTTP.post('/manage-website/branches/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.branch_list = res.data.object
            }
          })
    },
    edit_id(branch_id) {
      this.edit_modal = true
      this.edit_branch_data(branch_id)
    },
    edit_branch_data(branch_id) {
      this.loading_modal = true
      HTTP.post('/manage-website/branches/branch', {
        id: branch_id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.edit_branch_list = res.data.object
        }
      })
    },
    save_data() {
      if (this.$refs.add_branch.validate()) {
        Swal.fire({
          title: 'คุณต้องการบันทึกข้อมูลหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            HTTP.post('/manage-website/branches/create', {
              branch_name: this.send_data.branch_name,
              branch_telephone: this.send_data.telephone,
              branch_map: this.send_data.map_link,
              user_id: this.$store.state.userDetail.id,
              user_name: this.$store.state.userDetail.name,
            }).then((res) => {
              if (res.data.success === true) {
                this.create_modal = false
                this.alert_success = true
                this.send_data.branch_name = null
                this.send_data.telephone = null
                this.send_data.map_link = null
                setTimeout(() => this.alert_success = false, 3000)
                this.get_branch_data()
              }
            })
          }
        })
      }
    },
    edit_data() {
      if (this.$refs.edit_branch.validate()) {
        Swal.fire({
          title: 'คุณต้องการบันทึกข้อมูลหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            HTTP.post('/manage-website/branches/update', {
              id: this.edit_branch_list.id,
              branch_name: this.edit_branch_list.branch_name,
              branch_telephone: this.edit_branch_list.branch_telephone,
              branch_map: this.edit_branch_list.branch_map,
            }).then((res) => {
              if (res.data.success === true) {
                this.edit_modal = false
                this.get_branch_data()
                this.alert_success = true
                setTimeout(() => this.alert_success = false, 3000)
              }
            })
          }
        })
      }
    },
    delete_data(branch_id) {
      Swal.fire({
        title: 'คุณต้องการลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/branches/delete', {
            id: branch_id,
          }).then((res) => {
            if (res.data.success === true) {
              this.get_branch_data()
              this.alert_delete = true
              setTimeout(() => this.alert_delete = false, 1000)
            }
          })
        }
      })
    }
  },
  mounted() {
    this.get_branch_data()
  }
}
</script>

<style scoped>
.mobile_btn {
  width: 20%;
}
.hover_font {
  color: black;
}
.hover_font:hover {
  color: #8cc63e;
  cursor: pointer;
}
@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
